import * as R from "ramda";

export default function(value) {
  return R.isEmpty(value) || R.isNil(value);
}
